import DgTopicTreeMgr from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgTopicTreeMgr.install = function (Vue) {
  Vue.component(DgTopicTreeMgr.name, DgTopicTreeMgr)
}
export default DgTopicTreeMgr

export { DgTopicTreeMgr }